import _ from 'lodash-extended';

export default class GlobalContext {
  static parse(tk) {
    if (!tk) {
      console.error('missing global context');
    }

    // sort story categories
    const { storyCategories } = tk.context;
    if (!_.isEmpty(storyCategories)) {
      tk.context.storyCategories = _.sortBy(storyCategories, 'label');
    }

    if (!_.isEmpty(tk.context.annotationTypes)) {
      tk.context.annotationTypes = tk.context.annotationTypes.sort(function (
        a,
        b
      ) {
        return a < b ? 1 : a === b ? 0 : -1;
      }); // desc
    }

    if (!_.isEmpty(tk.context.relatedProgrammerList)) {
      tk.context.relatedProgrammerList.sort(function (a, b) {
        a.label = a.label || '';
        b.label = b.label || '';
        return a.label.localeCompare(b.label);
      }); // asc
    }

    // transform Language list of strings to list of object enum value and display text for use in drop-down
    if (!_.isEmpty(tk.context.languages)) {
      const arr = [];
      _.each(tk.context.languages, function (lang) {
        if (!/UNKNOWN/i.test(lang)) {
          // skip potentially unwanted values
          arr.push({ value: lang, text: _.capitalize(lang) });
        }
      });
      arr.sort(function (a, b) {
        return a.text < b.text ? -1 : a.text == b.text ? 0 : 1;
      });
      tk.context.languages = arr;
    }

    tk.context._supportedFileExtensions = _.map(
      tk.context.mimeTypes,
      function (obj) {
        return obj.enumStr.replace(/^_/, '');
      }
    );

    tk.context._editorialProviders = [];
    tk.context._commercialProviders = [];
    _.each(tk.context.allProviders, (tmpProvider) => {
      const rights = tmpProvider.rights;
      if (rights) {
        const sepearatedIds = tmpProvider.id.split('|');
        _.each(sepearatedIds, (sepearatedId) => {
          if (rights === 'EDITORIAL') {
            tk.context._editorialProviders.push(sepearatedId);
          } else if (rights === 'COMMERCIAL') {
            tk.context._commercialProviders.push(sepearatedId);
          }
        });
      }
    });

    _.mapKeys(
      tk.context.allProviders.filter((val) => {
        return val.rights === 'COMMERCIAL';
      }),
      'id'
    );

    tk.context._editableProviders = Object.keys(
      _.mapKeys(
        tk.context.allProviders.filter((p) => {
          return p.editable;
        }),
        'id'
      )
    );

    tk.context._expirationExcludeProviders = _.mapKeys(
      tk.context.allProviders.filter((val) => {
        return val.expirationEnforcement === false;
      }),
      'id'
    );

    /**
     * Intended to show "My Team" option in storyboards category filters
     * It is set by BE basing on allowed Programmers to show in storyboard dashboard
     * if wochit programmers are not in this set then this prop is false
     */
    tk.context.inheritStoryboardsFromChannel =
      !!tk.context.inheritStoryboardsFromChannel;
    return tk;
  }
}
